<template lang="pug">
div
  ChapterView(:book="book")
  //- FeedbackForm(:entityId="book.id" entityType="Content" message="Have feedback on the book?")
</template>

<script>
import { BookWithChapter } from '~/graphql/Book.gql';
import ChapterView from '~/components/BookViewer/ChapterView';
import FeedbackForm from '~/components/forms/FeedbackForm';
import { generateContentSeo, getPath } from '~/utils/seo';

export default {
  i18nLocaleRoot: '/books',
  meta: {
    logoText: 'books',
    theme: 'books'
  },
  components: {
    ChapterView,
    FeedbackForm
  },
  head() {
    const chapter = this.book.chapter.node;
    const content = {
      title: chapter.title,
      description: getPath('seo.facebook.description', chapter, this.book.description),
      thumb: chapter.thumb,
      seo: chapter.seo || this.book.seo
    };

    const meta = generateContentSeo(content);

    return {
      ...meta,
      titleTemplate: `%s - ${this.book.title} - ${this.$t('siteName')}`
    };
  },
  async asyncData({ app, params, error, redirect, route }) {
    try {
      const { data } = await app.$api.query({
        query: BookWithChapter,
        variables: {
          slug: params.slug,
          chapter: params.chapter
        }
      });

      if (!data || !data.book) {
        error({ statusCode: 404, message: 'BOOK_NOT_FOUND' });
        return;
      }

      if (data.book.slug !== params.slug) {
        return redirect(route.path.replace(params.slug, data.book.slug));
      }

      if (!data.book.chapter) {
        error({ statusCode: 404, message: 'CHAPTER_NOT_FOUND' });
        return;
      }

      app.applyContentTheme(data.book);
      app.verifyContentLocale(data.book);

      return {
        book: data.book
      };
    } catch (err) {
      error({ statusCode: 404 });
    }
  }
};
</script>
